// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Tile":"Tile-4mpej8yumd6bz9ry8yze8pyjna1mjnvup2b2ft956g4qxhk11ve36uah9z7rbeukawusb6apummpvqg36rtc2k2uesaam8pzy8rs9ns","Overlay":"Overlay-27dvawzg3jgytktnmga3qc8x9wv1wqhnvk8f6apum8f56e3rtqwe61r9ywdyga6be8xzxg3vzch6vrt1e2uyw41963af59qmpt8zs4h","loading":"loading-26kq6z9jgcs45szgc3vb8hs3tvrabq8d7e9rsbytx7gtna65edfkrmbed35p6xc4bkubvhhnht975btsgbfnn4af4n8w55kh4cujrrz","pulse":"pulse-3gdn8h9e7tkqnw3n75t7yvkvdmj6zn4jamxcmgtmtc6szmh5acgne8knbj9htgczvmuwt68wg1a4se2ubhvexry83tt9b8aubrpecd4"};


//////////////////
// WEBPACK FOOTER
// ./src/views/CSR/components/GroupTile/GroupTile.module.scss
// module id = 1612
// module chunks = 0